import styled from '@emotion/styled'
import GlCellBody from '../../../../share/table/GlCellBody'
import GlBadge from '../../../../share/badge/GlBadge'
import RankTitle from '../../../../trends/body/RankTitle'
import { AuthorMirrorAuthorInterface } from '../../../../../core/interface/report/author-mirror-author.interface'
import ComputePercentageUtils from '../../../../../core/utils/compute-percentage.utils'

const LineStyle = styled.div`
  ${({ hasSelect, hasHover }: { hasSelect: boolean; hasHover: boolean }) =>
    (hasHover &&
      `
      background-color: #e3e3e3 !important;
    `) ||
    (hasSelect &&
      `
    &:hover {
      background-color: #f7f7f7 !important;
    }
  
    &:active {
      background-color: #e3e3e3 !important;
    }
  `)}
`

const ProximityStyle = styled.div`
  color: #3b3b3b;
  text-align: center;
  font-family: 'Fira Sans';
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0.24px;
  padding: 0px 4px;
`

const AnalyticDetailsTableBody = ({
  authorsOutput,
  handleAuthorSelected,
  authorDetailsSelected,
  hasSelect,
  authorIdHovered,
}: {
  authorsOutput: AuthorMirrorAuthorInterface[]
  handleAuthorSelected: (author: AuthorMirrorAuthorInterface) => void
  authorDetailsSelected: AuthorMirrorAuthorInterface | null
  hasSelect: boolean
  authorIdHovered: string | null
}) => {
  return (
    <div className="flex grow flex-col">
      {authorsOutput.map(
        (author: AuthorMirrorAuthorInterface, index: number) => (
          <LineStyle
            id={`line-table-${author.author_id}`}
            hasSelect={hasSelect}
            hasHover={authorIdHovered === author.author_id}
            key={`line-table-${author.author_id}`}
            style={{
              backgroundColor:
                hasSelect &&
                authorDetailsSelected?.author_id === author.author_id
                  ? '#e3e3e3'
                  : 'white',
              borderRadius:
                index + 1 === authorsOutput.length ? '0 0 16px 16px' : 'none',
            }}
            className={`
            cursor-pointer
            bg-white
            flex
            flex-row
            hover:bg-[#f7f7f7]
            active:bg-[#e3e3e3]
            ${authorsOutput.length > index + 1 ? 'border-b-2' : ''}
          `}
            onClick={() => {
              handleAuthorSelected(author)
            }}
          >
            <GlCellBody
              className="min-w-[80px] max-w-[80px]"
              labelValue={author?.distance}
            >
              <div className="flex flex-row items-center justify-start gap-1">
                <GlBadge label={`${author?.position || index + 1}`} />
                <ProximityStyle>
                  {ComputePercentageUtils(author?.distance as number)}
                </ProximityStyle>
              </div>
            </GlCellBody>
            <GlCellBody className="min-w-[238px] max-w-[238px]">
              <RankTitle title={author?.author?.name} titleOnly />
            </GlCellBody>
          </LineStyle>
        ),
      )}
    </div>
  )
}

export default AnalyticDetailsTableBody
